import { api } from "@shared/lib/api";
import { BackednResponse } from "@shared/lib/types";
import { IActivityLogSearchQuery, IActivityLogSearchResponse } from "../types";

export class ActivityService {
  public static async searchActivityLogs({
    pageNo,
    limit,
    searchQuery,
    briefInfluencerIds,
    types,
    subTypes,
    brandIds,
    activityDate,
    brandOrganisationIds,
  }: IActivityLogSearchQuery) {
    const url = `activity-logs/search`;
    return (await api
      .post(url, {
        json: {
          pageNo,
          limit,
          searchQuery,
          briefInfluencerIds,
          types,
          subTypes,
          brandIds,
          activityDate,
          brandOrganisationIds,
        },
      })
      .json()) as BackednResponse<IActivityLogSearchResponse>;
  }
}
